(function initializeBundleBox() {
  function normalizeColorToken(colorValue) {
    return String(colorValue || "").trim().toLowerCase();
  }

  function normalizeSizeToken(sizeValue) {
    return String(sizeValue || "").split("(")[0].trim().toLowerCase();
  }

  function getSizeGuideText(bundleBoxElement, sizeValue) {
    if (!sizeValue) {
      return "";
    }

    var sizePillElement = bundleBoxElement.querySelector(
      '#sizeA .spill[data-size="' + sizeValue.replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '"]'
    );
    var sizeGuideText = sizePillElement ? sizePillElement.getAttribute("data-size-guide") || "" : "";

    if (!sizeGuideText) {
      return "";
    }

    var openParenIndex = sizeGuideText.indexOf("(");
    if (openParenIndex === -1) {
      return sizeGuideText;
    }

    var closeParenIndex = sizeGuideText.lastIndexOf(")");
    if (closeParenIndex > openParenIndex) {
      return sizeGuideText.slice(openParenIndex + 1, closeParenIndex).trim();
    }

    return sizeGuideText;
  }

  function updateSizeGuideLabel(bundleBoxElement, sizeValue) {
    var sizeGuideElement = bundleBoxElement.querySelector("#sizeGuideA");
    var sizeGuideLabelElement = sizeGuideElement && sizeGuideElement.querySelector(".size-guide-label");
    if (!sizeGuideElement || !sizeGuideLabelElement) {
      return;
    }

    var sizeGuideText = getSizeGuideText(bundleBoxElement, sizeValue);
    sizeGuideElement.hidden = !sizeGuideText;
    sizeGuideLabelElement.textContent = sizeGuideText;
  }

  function concatVariantChunksFromScriptElements(chunkScriptElements) {
    var mergedVariantList = [];
    for (var chunkIndex = 0; chunkIndex < chunkScriptElements.length; chunkIndex += 1) {
      var chunkArray = JSON.parse(chunkScriptElements[chunkIndex].textContent);
      if (!Array.isArray(chunkArray)) {
        continue;
      }
      for (var itemIndex = 0; itemIndex < chunkArray.length; itemIndex += 1) {
        mergedVariantList.push(chunkArray[itemIndex]);
      }
    }
    return mergedVariantList;
  }

  function parseVariantRowsFromFetchedProductHtml(responseHtmlText) {
    var parsedDocument = new DOMParser().parseFromString(responseHtmlText, "text/html");
    var responseRootElement = parsedDocument.querySelector(".bundle-box-variants-data-root");
    if (!responseRootElement) {
      return [];
    }
    return concatVariantChunksFromScriptElements(
      responseRootElement.querySelectorAll("script.bundle-box-variants-chunk[type='application/json']")
    );
  }

  function truncateVariantRowsToMaxPerPage(variantRows, maxVariantRowsPerPage) {
    if (variantRows.length <= maxVariantRowsPerPage) {
      return variantRows;
    }
    return variantRows.slice(0, maxVariantRowsPerPage);
  }

  function flattenVariantRowsPerPageWithDedupeById(variantRowsPerPage) {
    var seenVariantIdSet = new Set();
    var flatVariantList = [];
    for (var pageIndex = 0; pageIndex < variantRowsPerPage.length; pageIndex += 1) {
      var onePageVariantRows = variantRowsPerPage[pageIndex];
      for (var rowIndex = 0; rowIndex < onePageVariantRows.length; rowIndex += 1) {
        var variantRow = onePageVariantRows[rowIndex];
        if (!variantRow || variantRow.id == null) {
          continue;
        }
        var variantIdNumber = Number(variantRow.id);
        if (seenVariantIdSet.has(variantIdNumber)) {
          continue;
        }
        seenVariantIdSet.add(variantIdNumber);
        flatVariantList.push(variantRow);
      }
    }
    return flatVariantList;
  }

  function buildFetchUrlForProductVariantPage(pageNumber) {
    var url = new URL(window.location.href);
    url.searchParams.delete("section_id");
    url.searchParams.delete("variant");
    url.searchParams.set("page", String(pageNumber));
    return url.pathname + url.search;
  }

  function loadVariantListAsync(bundleBoxElement, doneCallback) {
    var dataRootElement = bundleBoxElement.querySelector(".bundle-box-variants-data-root");
    if (!dataRootElement) {
      doneCallback(null);
      return;
    }

    var rawRowsFromDomChunk = concatVariantChunksFromScriptElements(
      dataRootElement.querySelectorAll("script.bundle-box-variants-chunk[type='application/json']")
    );
    var pageSizeFromMeta = 250;
    var totalPages = 1;
    var currentPageFromMeta = 1;
    var metaElement = dataRootElement.querySelector("script.bundle-box-variants-pagination-meta[type='application/json']");
    if (metaElement) {
      try {
        var metaObject = JSON.parse(metaElement.textContent);
        var parsedVariantsCount = Number(metaObject.variantsCount);
        var parsedPageSize = Number(metaObject.pageSize);
        if (Number.isFinite(parsedPageSize) && parsedPageSize > 0) {
          pageSizeFromMeta = parsedPageSize;
        }
        var parsedCurrentPage = Number(metaObject.currentPage);
        if (Number.isFinite(parsedCurrentPage) && parsedCurrentPage >= 1) {
          currentPageFromMeta = parsedCurrentPage;
        }
        var pagesFromPaginate = Math.max(1, Number(metaObject.pages) || 1);
        var variantsCountForPages = Number.isFinite(parsedVariantsCount) && parsedVariantsCount > 0 ? parsedVariantsCount : rawRowsFromDomChunk.length;
        var pagesFromVariantCount = Math.max(1, Math.ceil(variantsCountForPages / pageSizeFromMeta));
        totalPages = Math.max(pagesFromPaginate, pagesFromVariantCount);
      } catch (parseError) {
        totalPages = 1;
        currentPageFromMeta = 1;
      }
    }

    var variantRowsPerPage = [];

    function finishVariantRowsPerPageAndCallback() {
      var flatVariantList = flattenVariantRowsPerPageWithDedupeById(variantRowsPerPage);
      doneCallback(flatVariantList.length ? flatVariantList : null);
    }

    function loadRowsForVariantPageNumber(pageNumber) {
      if (pageNumber === currentPageFromMeta) {
        return Promise.resolve(truncateVariantRowsToMaxPerPage(rawRowsFromDomChunk, pageSizeFromMeta));
      }
      return fetch(buildFetchUrlForProductVariantPage(pageNumber))
        .then(function (response) {
          return response.text();
        })
        .then(function (responseHtmlText) {
          return truncateVariantRowsToMaxPerPage(
            parseVariantRowsFromFetchedProductHtml(responseHtmlText),
            pageSizeFromMeta
          );
        });
    }

    function loadSequentiallyFromPageNumber(pageNumber) {
      if (pageNumber > totalPages) {
        finishVariantRowsPerPageAndCallback();
        return;
      }
      loadRowsForVariantPageNumber(pageNumber)
        .then(function (rowsForPage) {
          variantRowsPerPage.push(rowsForPage);
          if (rowsForPage.length === 0) {
            finishVariantRowsPerPageAndCallback();
            return;
          }
          loadSequentiallyFromPageNumber(pageNumber + 1);
        })
        .catch(function () {
          finishVariantRowsPerPageAndCallback();
        });
    }

    loadSequentiallyFromPageNumber(1);
  }

  function initializeSingleBundleBox(bundleBoxElement) {
    loadVariantListAsync(bundleBoxElement, function (variantList) {
      if (!variantList || variantList.length === 0) {
        return;
      }

      var moneyFormat = bundleBoxElement.getAttribute("data-money-format") || "${{amount}}";
      var currencyCode = bundleBoxElement.getAttribute("data-currency-code") || "USD";
      var addToCartButtonElement = bundleBoxElement.querySelector("#bundleAtcButton");
      var addToCartPriceElement = bundleBoxElement.querySelector("#atcPriceA");
      var colorContainerElement = bundleBoxElement.querySelector("#colorA");
      var sizeContainerElement = bundleBoxElement.querySelector("#sizeA");
      var toggleRowElement = bundleBoxElement.querySelector("#toggleRowA");
      var toggleSwitchElement = bundleBoxElement.querySelector("#toggleSwitchA");
      var selRowElement = bundleBoxElement.querySelector(".sel-row");
      var perPairContainerElement = bundleBoxElement.querySelector("#ppA");
      var shippingStripElement = bundleBoxElement.querySelector("#shippingStripA");

      if (!addToCartButtonElement || !addToCartPriceElement || !colorContainerElement || !sizeContainerElement || !toggleRowElement || !toggleSwitchElement || !perPairContainerElement) {
        return;
      }

      var productFormElement =
        bundleBoxElement.closest('form[is="product-form"]')
        || bundleBoxElement.closest("form.main-product-form")
        || bundleBoxElement.closest("form[data-type='add-to-cart-form']");
      var variantIdInputElement = productFormElement
        ? productFormElement.querySelector("input.product-variant-id, input[name='id']")
        : null;
      var paymentButtonContainerElement = productFormElement
        ? productFormElement.querySelector(".shopify-payment-button")
        : null;
      var formPropertiesContainerElement = null;

      function formatMoney(priceInCents) {
        var numericCents = Number(priceInCents) || 0;
        if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
          return window.Shopify.formatMoney(numericCents, moneyFormat);
        }

        return new Intl.NumberFormat(undefined, {
          style: "currency",
          currency: currencyCode,
          maximumFractionDigits: 2
        }).format(numericCents / 100);
      }

      var selectedOfferElement = bundleBoxElement.querySelector(".bcard.sel");
      var selectedColorElement = colorContainerElement.querySelector(".cdot.sel");
      var selectedSizeElement = sizeContainerElement.querySelector(".spill.sel");

      var state = {
        selectedOffer: selectedOfferElement ? selectedOfferElement.getAttribute("data-offer") : "",
        selectedColor: selectedColorElement ? selectedColorElement.getAttribute("data-color") : "",
        selectedSize: selectedSizeElement ? selectedSizeElement.getAttribute("data-size") : "",
        selectedVariantId: selectedOfferElement ? Number(selectedOfferElement.getAttribute("data-variant-id")) : null,
        selectedPrice: selectedOfferElement ? Number(selectedOfferElement.getAttribute("data-price")) : 0,
        selectedPairsCount: selectedOfferElement ? Number(selectedOfferElement.getAttribute("data-pairs")) : 2,
        customOpen: false,
        pairSelectionMap: {}
      };

      function buildLineItemProperties() {
        var lineItemProperties = {
          Tier: state.selectedOffer
        };

        for (var pairNumber = 1; pairNumber <= state.selectedPairsCount; pairNumber += 1) {
          if (state.customOpen && state.pairSelectionMap[pairNumber]) {
            lineItemProperties["Pair " + pairNumber] =
              state.pairSelectionMap[pairNumber].color + " - " + state.pairSelectionMap[pairNumber].size;
          } else {
            lineItemProperties["Pair " + pairNumber] = state.selectedColor + " - " + state.selectedSize;
          }
        }

        return lineItemProperties;
      }

      function setAcceleratedCheckoutEnabled(isEnabled) {
        if (paymentButtonContainerElement) {
          paymentButtonContainerElement.querySelectorAll("button, [role='button']").forEach(function (paymentButtonElement) {
            paymentButtonElement.disabled = !isEnabled;
            paymentButtonElement.setAttribute("aria-disabled", isEnabled ? "false" : "true");
          });
        }

        if (
          window.ShopPay
          && window.ShopPay.PaymentRequest
          && window.ShopPay.PaymentRequest.Buttons
        ) {
          if (isEnabled && typeof window.ShopPay.PaymentRequest.Buttons.enable === "function") {
            window.ShopPay.PaymentRequest.Buttons.enable();
          } else if (!isEnabled && typeof window.ShopPay.PaymentRequest.Buttons.disable === "function") {
            window.ShopPay.PaymentRequest.Buttons.disable();
          }
        }
      }

      function syncProductFormForCheckout(matchingVariant) {
        if (!productFormElement) {
          return;
        }

        var hasValidVariant = Boolean(matchingVariant && matchingVariant.id);

        if (variantIdInputElement) {
          if (hasValidVariant) {
            variantIdInputElement.disabled = false;
            variantIdInputElement.value = String(matchingVariant.id);
            variantIdInputElement.dispatchEvent(new Event("change", { bubbles: true }));
          } else {
            variantIdInputElement.disabled = true;
          }
        }

        if (!formPropertiesContainerElement) {
          formPropertiesContainerElement = document.createElement("div");
          formPropertiesContainerElement.className = "bundle-box-form-properties";
          formPropertiesContainerElement.hidden = true;
          formPropertiesContainerElement.setAttribute("aria-hidden", "true");
          productFormElement.appendChild(formPropertiesContainerElement);
        }

        formPropertiesContainerElement.innerHTML = "";

        if (hasValidVariant) {
          var lineItemProperties = buildLineItemProperties();
          Object.keys(lineItemProperties).forEach(function (propertyName) {
            var propertyInputElement = document.createElement("input");
            propertyInputElement.type = "hidden";
            propertyInputElement.name = "properties[" + propertyName + "]";
            propertyInputElement.value = lineItemProperties[propertyName];
            formPropertiesContainerElement.appendChild(propertyInputElement);
          });
        }

        setAcceleratedCheckoutEnabled(hasValidVariant);

        if (hasValidVariant) {
          document.dispatchEvent(
            new CustomEvent("variant:changed", {
              detail: {
                variant: matchingVariant
              }
            })
          );
        }
      }

      function findMatchingVariant() {
        return variantList.find(function (variantItem) {
          if (variantItem.option1 !== state.selectedOffer) {
            return false;
          }

          var variantColorTokens = String(variantItem.option2 || "").split(",");
          var variantSizeTokens = String(variantItem.option3 || "").split(",");

          if (state.customOpen) {
            var variantPairKeys = [];
            for (var index = 0; index < variantColorTokens.length; index += 1) {
              variantPairKeys.push(normalizeColorToken(variantColorTokens[index]) + "|" + normalizeSizeToken(variantSizeTokens[index]));
            }
            var selectedPairKeys = [];
            for (var pairIndex = 1; pairIndex <= state.selectedPairsCount; pairIndex += 1) {
              var pairSelection = state.pairSelectionMap[pairIndex] || { color: state.selectedColor, size: state.selectedSize };
              selectedPairKeys.push(normalizeColorToken(pairSelection.color) + "|" + normalizeSizeToken(pairSelection.size));
            }
            return variantPairKeys.sort().join(",") === selectedPairKeys.sort().join(",");
          }

          var expectedColor = normalizeColorToken(state.selectedColor);
          var expectedSize = normalizeSizeToken(state.selectedSize);
          for (var tokenIndex = 0; tokenIndex < variantColorTokens.length; tokenIndex += 1) {
            if (normalizeColorToken(variantColorTokens[tokenIndex]) !== expectedColor) {
              return false;
            }
          }
          for (var sizeIndex = 0; sizeIndex < variantSizeTokens.length; sizeIndex += 1) {
            if (normalizeSizeToken(variantSizeTokens[sizeIndex]) !== expectedSize) {
              return false;
            }
          }
          return true;
        });
      }

      function updateSelectedVariant() {
        var matchingVariant = findMatchingVariant();
        updateShippingStripVisibility();
        if (matchingVariant) {
          state.selectedVariantId = matchingVariant.id;
          state.selectedPrice = Number(matchingVariant.price);
          addToCartButtonElement.disabled = false;
          addToCartPriceElement.textContent = formatMoney(state.selectedPrice);
          updateBrowserUrlVariant(state.selectedVariantId);
        } else {
          state.selectedVariantId = null;
          addToCartButtonElement.disabled = true;
          addToCartPriceElement.textContent = "";
        }
        syncProductFormForCheckout(matchingVariant);
      }

      function updateShippingStripVisibility() {
        if (!shippingStripElement) {
          return;
        }
        shippingStripElement.style.display = state.selectedPairsCount >= 4 ? "flex" : "none";
      }

      function updateBrowserUrlVariant(selectedVariantId) {
        if (!selectedVariantId || !window.history || typeof window.history.replaceState !== "function") {
          return;
        }

        var currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set("variant", String(selectedVariantId));
        window.history.replaceState({}, "", currentUrl.toString());
      }

      function openCartDrawer() {
        document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { open: true } }));

        var cartDrawerElement = document.querySelector("cart-drawer");
        if (cartDrawerElement && typeof cartDrawerElement.show === "function") {
          cartDrawerElement.show();
        }
      }

      function escapeHtmlAttributeValue(attributeValue) {
        return String(attributeValue || "")
          .replace(/&/g, "&amp;")
          .replace(/"/g, "&quot;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;");
      }

      function escapeHtmlText(textValue) {
        return String(textValue || "")
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;");
      }

      function buildPairRowElement(pairIndex) {
        if (!state.pairSelectionMap[pairIndex]) {
          state.pairSelectionMap[pairIndex] = {
            color: state.selectedColor,
            size: state.selectedSize
          };
        }

        var pairSelection = state.pairSelectionMap[pairIndex];
        var pairRowElement = document.createElement("div");
        pairRowElement.className = "pp-row";
        var pairSizeGuideText = getSizeGuideText(bundleBoxElement, pairSelection.size);

        var colorDotHtml = "";
        colorContainerElement.querySelectorAll(".cdot").forEach(function (colorDotElement) {
          var colorValue = colorDotElement.getAttribute("data-color");
          var selectedClassName = pairSelection.color === colorValue ? " sel" : "";
          var backgroundColor = colorDotElement.style.backgroundColor;
          colorDotHtml += '<div class="cdot' + selectedClassName + '" data-pair-index="' + pairIndex + '" data-pair-color="' + escapeHtmlAttributeValue(colorValue) + '" style="background-color:' + backgroundColor + ';"></div>';
        });

        var sizePillHtml = "";
        sizeContainerElement.querySelectorAll(".spill").forEach(function (sizePillElement) {
          var sizeValue = sizePillElement.getAttribute("data-size");
          var selectedClassName = pairSelection.size === sizeValue ? " sel" : "";
          var sizeGuideValue = sizePillElement.getAttribute("data-size-guide") || "";
          sizePillHtml +=
            '<div class="spill' + selectedClassName + '" data-pair-index="' + pairIndex + '" data-pair-size="' + escapeHtmlAttributeValue(sizeValue) + '" data-size-guide="' + escapeHtmlAttributeValue(sizeGuideValue) + '">' + sizePillElement.textContent + "</div>";
        });

        pairRowElement.innerHTML =
          '<div class="pp-header"><div class="pp-label">Pair ' + pairIndex + "</div></div>"
          + '<div class="pp-selectors">'
          + '<div class="pp-sel-label pp-sel-label--color">Color</div><div class="color-row">' + colorDotHtml + "</div>"
          + '<div class="pp-size-group">'
          + '<div class="pp-size-head">'
          + '<div class="size-guide-wrap pp-size-guide"' + (pairSizeGuideText ? "" : " hidden") + ' aria-live="polite">'
          + '<span class="size-guide-label">' + escapeHtmlText(pairSizeGuideText) + "</span>"
          + "</div>"
          + "</div>"
          + '<div class="pp-sel-label">Size</div>'
          + '<div class="size-row pp-size-row">' + sizePillHtml + "</div>"
          + "</div>"
          + "</div>";

        return pairRowElement;
      }

      function renderPerPairRows() {
        perPairContainerElement.innerHTML = "";
        for (var pairIndex = 1; pairIndex <= state.selectedPairsCount; pairIndex += 1) {
          perPairContainerElement.appendChild(buildPairRowElement(pairIndex));
        }
      }

      function updateOfferSelection(nextOfferCardElement) {
        bundleBoxElement.querySelectorAll(".bcard").forEach(function (offerCardElement) {
          offerCardElement.classList.remove("sel");
        });
        nextOfferCardElement.classList.add("sel");

        state.selectedOffer = nextOfferCardElement.getAttribute("data-offer");
        state.selectedPairsCount = Number(nextOfferCardElement.getAttribute("data-pairs"));
        state.pairSelectionMap = {};
        if (state.customOpen) {
          renderPerPairRows();
        }
        updateSelectedVariant();
      }

      colorContainerElement.addEventListener("click", function (event) {
        var nextColorDotElement = event.target.closest(".cdot");
        if (!nextColorDotElement) {
          return;
        }
        colorContainerElement.querySelectorAll(".cdot").forEach(function (colorDotElement) {
          colorDotElement.classList.remove("sel");
        });
        nextColorDotElement.classList.add("sel");
        state.selectedColor = nextColorDotElement.getAttribute("data-color");
        updateSelectedVariant();
      });

      sizeContainerElement.addEventListener("click", function (event) {
        var nextSizePillElement = event.target.closest(".spill");
        if (!nextSizePillElement) {
          return;
        }
        sizeContainerElement.querySelectorAll(".spill").forEach(function (sizePillElement) {
          sizePillElement.classList.remove("sel");
        });
        nextSizePillElement.classList.add("sel");
        state.selectedSize = nextSizePillElement.getAttribute("data-size");
        updateSizeGuideLabel(bundleBoxElement, state.selectedSize);
        updateSelectedVariant();
      });

      bundleBoxElement.querySelectorAll(".bcard").forEach(function (offerCardElement) {
        offerCardElement.addEventListener("click", function () {
          if (window.clarity) {
            window.clarity("event", "bundle_selector_clicked");
          }
          updateOfferSelection(offerCardElement);
        });
      });

      toggleRowElement.addEventListener("click", function () {
        state.customOpen = !state.customOpen;
        toggleSwitchElement.classList.toggle("on", state.customOpen);
        perPairContainerElement.classList.toggle("open", state.customOpen);
        if (selRowElement) {
          selRowElement.style.display = state.customOpen ? "none" : "";
        }
        if (state.customOpen) {
          renderPerPairRows();
        } else {
          perPairContainerElement.innerHTML = "";
          state.pairSelectionMap = {};
        }
        updateSelectedVariant();
      });

      perPairContainerElement.addEventListener("click", function (event) {
        var copyButtonElement = event.target.closest("[data-copy-pair-index]");
        if (copyButtonElement) {
          var copyTargetPairIndex = Number(copyButtonElement.getAttribute("data-copy-pair-index"));
          if (state.pairSelectionMap[1]) {
            state.pairSelectionMap[copyTargetPairIndex] = {
              color: state.pairSelectionMap[1].color,
              size: state.pairSelectionMap[1].size
            };
            renderPerPairRows();
          }
          return;
        }

        var pairColorElement = event.target.closest("[data-pair-color]");
        if (pairColorElement) {
          var pairColorIndex = Number(pairColorElement.getAttribute("data-pair-index"));
          if (!state.pairSelectionMap[pairColorIndex]) {
            state.pairSelectionMap[pairColorIndex] = { color: state.selectedColor, size: state.selectedSize };
          }
          state.pairSelectionMap[pairColorIndex].color = pairColorElement.getAttribute("data-pair-color");
          renderPerPairRows();
          updateSelectedVariant();
          return;
        }

        var pairSizeElement = event.target.closest("[data-pair-size]");
        if (pairSizeElement) {
          var pairSizeIndex = Number(pairSizeElement.getAttribute("data-pair-index"));
          if (!state.pairSelectionMap[pairSizeIndex]) {
            state.pairSelectionMap[pairSizeIndex] = { color: state.selectedColor, size: state.selectedSize };
          }
          state.pairSelectionMap[pairSizeIndex].size = pairSizeElement.getAttribute("data-pair-size");
          renderPerPairRows();
          updateSelectedVariant();
        }
      });

      addToCartButtonElement.addEventListener("click", function () {
        // ✅ ADDED: track ATC click intent
        if (window.clarity) {
          window.clarity("event", "bundle_add_to_cart_click");
        }

        if (!state.selectedVariantId) {
          return;
        }

        var lineItemProperties = buildLineItemProperties();
        var addToCartLabelElement = addToCartButtonElement.querySelector(".atc-label");
        addToCartButtonElement.disabled = true;
        addToCartLabelElement.textContent = "Adding...";

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [
              {
                id: state.selectedVariantId,
                quantity: 1,
                properties: lineItemProperties
              }
            ]
          })
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error("Add to cart failed");
            }
            return response.json();
          })
          .then(function () {
            // ✅ ADDED: track successful add to cart
            if (window.clarity) {
              window.clarity("event", "bundle_add_to_cart_success");
            }
            addToCartLabelElement.textContent = "Added to Cart!";
            openCartDrawer();
            setTimeout(function () {
              addToCartLabelElement.textContent = "Add to Cart";
              addToCartButtonElement.disabled = false;
            }, 1200);
          })
          .catch(function () {
            addToCartLabelElement.textContent = "Try again";
            addToCartButtonElement.disabled = false;
          });
      });

      updateSizeGuideLabel(bundleBoxElement, state.selectedSize);
      updateSelectedVariant();

      // Auto-select Buy 2, Get 2 FREE on page load
      var buy2Card = bundleBoxElement.querySelector('.bcard[data-offer="Buy 2, Get 2 FREE"]');
      if (buy2Card) {
        updateOfferSelection(buy2Card);
      }
    });
  }

  class BundleBoxRootElement extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bundleBoxInitialized === "true") {
        return;
      }
      this.dataset.bundleBoxInitialized = "true";
      initializeSingleBundleBox(this);
    }
  }

  if (!customElements.get("bundle-box-root")) {
    customElements.define("bundle-box-root", BundleBoxRootElement);
  }
})();
